import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n        display: flex;\n        align-items: center;\n        padding: ", ";\n        width: 100%;\n        transition: ", ";\n        transition-property: background-color, color;\n        will-change: background-color, color;\n        cursor: pointer;\n        box-sizing: border-box;\n        border-radius: 3px;\n\n        &:hover {\n            ", "\n        }\n\n        &:nth-child(n + 2) {\n            margin-top: ", ";\n        }\n\n        ", "\n        ", "\n        ", "\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n    font-weight: ", ";\n\n    ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        font-size: 16px;\n        margin: 0;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    align-items: center;\n\n    ", "\n\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { Icon, Text } from '../../../Atoms';
export var StyledIcon = styled(Icon)(_templateObject(), function (props) {
  return "\n        width: ".concat(props.theme.components.sideNav.item.icon.width, ";\n        margin-right: ").concat(props.theme.components.sideNav.item.icon.margin, ";\n    ");
});
export var StyledTitle = styled(Text)(_templateObject2(), function (props) {
  return "\n        color: inherit;\n        line-height: inherit;\n        font-size: inherit;\n        font-weight: inherit;\n        margin: 0;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        max-width: 100%;\n\n        ".concat(props.subNavItem || props.collapsibleSubNavItem ? "\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    width: 100%;\n                    margin-left: 16px;\n\n                    &:after {\n                        margin-left: 8px;\n                        content: '\\203A';\n                        display: block;\n                        font-size: 24px;\n                    }\n                " : '', "\n    ");
});
export var StyledIconWrapper = styled.div(_templateObject3(), function (props) {
  return "\n        width: ".concat(props.theme.components.sideNav.item.icon.width, ";\n        max-width: ").concat(props.theme.components.sideNav.item.icon.maxWidth, ";\n        margin-right: ").concat(props.theme.components.sideNav.item.icon.margin, ";\n    ");
}, media.max.md(_templateObject4()));
export var StyledTitleWrapper = styled.div(_templateObject5(), function (props) {
  return "\n        transition: ".concat(props.theme.components.sideNav.transition, ";\n        width: 170px;\n\n        ").concat(props.collapsedMenu ? "\n            width: 0;\n        " : '', "\n\n        ").concat(props.mobile ? "\n            width: auto;\n        " : '', "\n    ");
});
export var StyledSelectedSideNavItem = function StyledSelectedSideNavItem(props) {
  return css(_templateObject6(), props.theme.components.sideNav.item.active.backgroundColor, props.theme.components.sideNav.item.active.color, props.theme.components.sideNav.item.active.fontWeight, props.mobile ? "\n            background-color: transparent;\n            color: ".concat(props.theme.components.sideNav.item.active.color, ";\n        ") : "");
};
export var StyledCollapsibleSubNavItem = function StyledCollapsibleSubNavItem() {
  return "\n    flex-direction: row;\n    justify-content: center: \n    flex: 1 1 0;\n";
};
export var StyledMobileSideNavItem = function StyledMobileSideNavItem() {
  return "\n    flex-direction: column;\n    justify-content: center;\n    flex: 1 1 0;\n\n    margin: 0;\n    padding: 0;\n    border-radius: 0;\n\n    overflow: hidden;\n    background-color: transparent;\n    color: unset;\n    font-size: 10px;\n\n    &:nth-child(n + 2) {\n        margin-top: 0;\n    }\n\n    ".concat(StyledIcon, " {\n        margin: 0;\n    }\n");
};
export var StyledSideNavItem = styled.div(_templateObject7(), function (props) {
  return css(_templateObject8(), props.theme.components.sideNav.item.padding, props.theme.components.sideNav.transition, StyledSelectedSideNavItem(props), props.theme.components.sideNav.item.marginTop, props.collapsibleSubNavItem ? StyledCollapsibleSubNavItem(props) : '', props.mobile && !props.collapsibleSubNavItem ? StyledMobileSideNavItem(props) : '', props.highlithed ? StyledSelectedSideNavItem(props) : '');
});